import React from "react";
import { AddTradeCustodianContainer } from "../../../containers";

const AddInvestment = (props) => {
  return <AddTradeCustodianContainer {...props} />;
};

export default AddInvestment;
